<template>
  <div class="py-5">
    <h4 class="text fw-bold">Contact details</h4>
    <p class="text-secondary" align="justify">
      Please, indicate your contact information here and we will contact you shortly
    </p>
    <div class="row">
      <div class="col-6">
        <h5 class="text">Name</h5>
        <input v-model="name" @keydown.enter.prevent type="text" class="form-control py-3 px-4" id="InputName" name="name_contact" placeholder="Ej. Carlos" required>
      </div>
      <div class="col-6">
        <h5 class="text">Email</h5>
        <input v-model="email" @keydown.enter.prevent  type="email" class="form-control py-3 px-4" id="InputEmail" name="email_contact" aria-describedby="emailHelp" placeholder="Ej. info@mail.com" required>
      </div>
      <div class="col-6 mt-2">
        <h5 class="text">Phone</h5>
        <input v-model="phone" @keydown.enter.prevent type="number" class="form-control py-3 px-4" id="InputPhone" name="phone_contact" placeholder="Ej. 312 123 4567" required>
      </div>
      <div class="col-6 mt-2">
        <h5 class="text">Enterprise name</h5>
        <input v-model="name_enterprise" @keydown.enter.prevent type="text" class="form-control py-3 px-4" id="InputEnterpriseName" name="enterprise_name_contact" placeholder="Ej. Helix Software" required>
      </div>
      <div class="col-12 my-4">
        <h5 class="text">Add a short description of your project</h5>
        <textarea v-model="localDescription" class="form-control mt-3 px-4" id="form-textarea" name="project_description" rows="10" placeholder="Description..." required></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",

  props:{
    contact: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      name: '',
      email: '',
      phone: '',
      name_enterprise: '',
      localDescription: this.description,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },

  watch: {
    name: function () {
      this.contact.pop();
      this.contact.push({ name: this.name, email: this.email, phone: this.phone, name_enterprise: this.name_enterprise });
      this.$emit('updatecontact', this.contact);
    },
    email: function () {
      this.contact.pop();
      this.contact.push({ name: this.name, email: this.email, phone: this.phone, name_enterprise: this.name_enterprise });
      this.$emit('updatecontact', this.contact);
    },
    phone: function () {
      this.contact.pop();
      this.contact.push({ name: this.name, email: this.email, phone: this.phone, name_enterprise: this.name_enterprise });
      this.$emit('updatecontact', this.contact);
    },
    name_enterprise: function () {
      this.contact.pop();
      this.contact.push({ name: this.name, email: this.email, phone: this.phone, name_enterprise: this.name_enterprise });
      this.$emit('updatecontact', this.contact);
    },
    localDescription: function () {
      this.$emit('updatedescription', this.localDescription);
    }
  }
}
</script>
